import React from 'react';

interface CardHeaderProps {
  chip?: React.ReactNode;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ chip, title, description, actions, className = '' }) => {
  return (
    <div className={`px-6 pt-4 pb-4 flex items-start justify-between ${className}`}>
      <div>
        {chip}
        <h2 className="text-lg font-medium mt-3 text-gray-900">{title}</h2>
        {description && <p className="text-sm text-gray-500 mt-1">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
};
